import React from 'react';
import { Card, Select, Form, ToggleContainer, TooltipHelp } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './settings.module.css';

export default function TicketOfficeOrderForm({ ticketOfficeSettingsForm, setTicketOfficeSettingsForm, hasModerationEnabled }) {
    const { t } = useTranslation();

    const accept_all_transaction_value = [
        { text: t('ticket.ticket_offices.parameters.form.order.accept_order_no_select'), value: 'ACCEPT_ORDER_NO' },
        { text: t('ticket.ticket_offices.parameters.form.order.accept_order_partner_select'), value: 'ACCEPT_ORDER_PARTNER' },
        { text: t('ticket.ticket_offices.parameters.form.order.accept_order_guichet_select'), value: 'ACCEPT_ORDER_GUICHET' },
        { text: t('ticket.ticket_offices.parameters.form.order.accept_order_all_select'), value: 'ACCEPT_ORDER_ALL' }
    ];

    accept_all_transaction_value.forEach((field, key) => {
        if (ticketOfficeSettingsForm.accept_all_transaction === String(key)) {
            return setTicketOfficeSettingsForm('accept_all_transaction', field.value);
        }
    });

    return (
        <div>
            <Card.FormStep
                title={t('ticket.ticket_offices.parameters.form.order.title')}
                subtitle={t('ticket.ticket_offices.parameters.form.order.descr2')}
                id="ticket-office-form-order"
                rightComponent
            >
                <Form.Field style={{ marginBottom: '0' }}>
                    <ToggleContainer
                        className={Style['toogle_container_margin']}
                        checked={ticketOfficeSettingsForm.accept_promotions_default}
                        tooltipProps={{ position: 'top' }}
                        title={t('ticket.ticket_offices.parameters.form.order.accept_promotion_default_label')}
                        helpLabel={t('ticket.ticket_offices.parameters.form.order.accept_promotion_default_helpLabel')}
                        onChange={(_, { checked }) => setTicketOfficeSettingsForm('accept_promotions_default', checked)}
                    />
                    <ToggleContainer
                        className={Style['toogle_container_margin']}
                        checked={ticketOfficeSettingsForm.send_copy_paidout}
                        tooltipProps={{ position: 'top' }}
                        title={t('ticket.ticket_offices.parameters.form.order.send_copy_paidout_label')}
                        helpLabel={t('ticket.ticket_offices.parameters.form.order.send_copy_paidout_helplabel')}
                        onChange={(_, { checked }) => setTicketOfficeSettingsForm('send_copy_paidout', checked)}
                    />
                    <ToggleContainer
                        className={Style['toogle_container_margin']}
                        checked={ticketOfficeSettingsForm.accept_booking}
                        tooltipProps={{ position: 'top' }}
                        title={t('ticket.ticket_offices.parameters.form.order.accept_booking_label')}
                        helpLabel={t('ticket.ticket_offices.parameters.form.order.accept_booking_helpLabel')}
                        onChange={(_, { checked }) => setTicketOfficeSettingsForm('accept_booking', checked)}
                    />
                    <ToggleContainer
                        checked={ticketOfficeSettingsForm.allow_refund}
                        tooltipProps={{ position: 'top' }}
                        title={t('ticket.ticket_offices.parameters.form.order.allow_refund_label')}
                        helpLabel={t('ticket.ticket_offices.parameters.form.order.allow_refund_helplabel')}
                        onChange={(_, { checked }) => setTicketOfficeSettingsForm('allow_refund', checked)}
                    />
                    <ToggleContainer
                        className={Style['toogle_container_margin']}
                        checked={ticketOfficeSettingsForm.allow_order_deletion}
                        tooltipProps={{ position: 'top' }}
                        title={t('ticket.ticket_offices.parameters.form.order.allow_order_deletion_label')}
                        helpLabel={t('ticket.ticket_offices.parameters.form.order.allow_order_deletion_helplabel')}
                        onChange={(_, { checked }) => setTicketOfficeSettingsForm('allow_order_deletion', checked)}
                    />
                    <ToggleContainer
                        className={Style['toogle_container_margin']}
                        checked={ticketOfficeSettingsForm.allow_invoice_printing}
                        tooltipProps={{ position: 'top' }}
                        title={t('ticket.ticket_offices.parameters.form.order.allow_invoice_printing_label')}
                        helpLabel={t('ticket.ticket_offices.parameters.form.order.allow_invoice_printing_helpLabel')}
                        onChange={(_, { checked }) => setTicketOfficeSettingsForm('allow_invoice_printing', checked)}
                    />
                    {hasModerationEnabled && (
                        <ToggleContainer
                            className={Style['toogle_container_margin']}
                            checked={ticketOfficeSettingsForm.display_only_approved_attendee}
                            tooltipProps={{ position: 'top' }}
                            title={t('ticket.ticket_offices.parameters.form.order.display_only_approved_attendee_label')}
                            helpLabel={t('ticket.ticket_offices.parameters.form.order.display_only_approved_attendee_helpLabel')}
                            onChange={(_, { checked }) => setTicketOfficeSettingsForm('display_only_approved_attendee', checked)}
                        />
                    )}

                    <Form.Field className={Style['toogle_container_margin']}>
                        <Form.Label>
                            {t('ticket.ticket_offices.parameters.form.order.accept_all_transaction_label')}
                            <TooltipHelp title={t('ticket.ticket_offices.parameters.form.order.accept_all_transaction_helplabel')} mini={false} position={'bottom'} />
                        </Form.Label>
                        <Select
                            options={accept_all_transaction_value}
                            value={ticketOfficeSettingsForm.accept_all_transaction}
                            onChange={(_, { value }) => setTicketOfficeSettingsForm('accept_all_transaction', value)}
                        />
                    </Form.Field>
                </Form.Field>
            </Card.FormStep>
        </div>
    );
}
